/** Entrada de UI: número de página o separador "…". */
export type CompactPaginationItem = number | 'ellipsis';

/**
 * Genera la secuencia compacta de páginas (p. ej. 1, 2, …, 7 o 2, 3, …, 7)
 * para no listar todos los números cuando hay muchas páginas.
 */
export function getCompactPaginationItems(
  currentPage: number,
  totalPages: number
): CompactPaginationItem[] {
  const c = currentPage;
  const T = totalPages;

  if (T <= 1) return [1];
  if (T <= 5) {
    return Array.from({ length: T }, (_, i) => i + 1);
  }

  if (c === 1) {
    return [1, 2, 'ellipsis', T];
  }
  if (c === 2) {
    return [2, 3, 'ellipsis', T];
  }
  if (c === 3) {
    return [1, 'ellipsis', 3, 4, 'ellipsis', T];
  }
  if (c >= T - 1) {
    if (c === T) {
      return [1, 'ellipsis', T - 1, T];
    }
    return [1, 'ellipsis', T - 2, T - 1, T];
  }
  if (c + 1 >= T - 1) {
    return [1, 'ellipsis', T - 2, T - 1, T];
  }
  return [1, 'ellipsis', c, c + 1, 'ellipsis', T];
}
